import { Observable, defer } from 'rxjs';

export function prepare<T>(callback: () => void): (source$: Observable<T>) => Observable<T> {
  return (source$: Observable<T>): Observable<T> =>
    defer(() => {
      callback();
      return source$;
    });
}
